import React from 'react'

const MyProfilePage = () => {
  return (
    <div>MyProfilePage</div>
  )
}

export default MyProfilePage